import React, { useState } from 'react';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import cookieCutter from 'cookie-cutter';
import { CgClose } from 'react-icons/cg';
import { GA_TYPE_COMPARE_PRODUCT, MARKETING_BUG_NAMES } from 'helpers/constants/aafes';
import useGATrackViewActions from 'helpers/hooks/gaEvents/useGATrackViewActions';
import { useFormat } from 'helpers/hooks/useFormat';
import Image from 'frontastic/lib/image';
import Link from 'frontastic/lib/link';
const LoginModal = dynamic(() => import('../Modals/Login/login'));
import PriceDetails from './priceDetails';
export default function ProductInfo({
  matchingVariants,
  isMarketPlaceItem,
  isUseFacilityBasedPrice,
  product,
  setIsLoad,
  fbpPrices,
}) {
  const router = useRouter();
  const { formatMessage } = useFormat({ name: 'common' });
  const [loginModal, setLoginModal] = useState(false);
  const { trackSelectItem } = useGATrackViewActions();
  const handleAppendURL = (skuToRemove) => {
    setIsLoad(true);
    const CURRENT_URL = window?.location?.href;
    const url = new URL(CURRENT_URL);
    const currentSkus = url?.searchParams?.get('skus');
    const storedCompareProducts = JSON.parse(cookieCutter.get('compareProducts') || '[]');
    if (currentSkus) {
      const skusArray = JSON?.parse(currentSkus);
      const updatedSkus = skusArray?.filter((sku) => sku !== skuToRemove);
      url?.searchParams?.set('skus', JSON?.stringify(updatedSkus));
      const updatedCompareProducts = storedCompareProducts?.filter((product) => product?.skuId !== skuToRemove);
      cookieCutter.set('compareProducts', JSON.stringify(updatedCompareProducts));
      router
        .push(url?.toString())
        .then(() => {
          setIsLoad(false);
        })
        .catch(() => setIsLoad(false));
    } else {
      setIsLoad(false);
    }
  };
  function closeLoginModal() {
    setLoginModal(false);
  }
  const handleSelectedProduct = (event, product) => {
    event.preventDefault();
    const trackObj = {
      product: product,
      type: GA_TYPE_COMPARE_PRODUCT,
    };
    trackSelectItem(trackObj);
    router.push(product?._url || 'https://www.shopmyexchange.com/');
  };
  const handleClick = (event) => {
    if (event.ctrlKey || event.metaKey) return;
    setIsLoad(true);
  };

  return (
    <>
      <div className="relative h-full w-full border-b border-r border-[#00000033] px-2 pt-6">
        {!isMarketPlaceItem && (
          <div
            className={`item-tag absolute top-0.5 left-3 ${matchingVariants?.marketingBug} rounded-[3px] px-2 py-0.5 text-xs font-bold leading-5 text-white`}
          >
            {MARKETING_BUG_NAMES?.[matchingVariants?.marketingBug]}
          </div>
        )}
        <div className="flex h-full gap-x-3 py-2">
          <div className="h-[75px] min-w-[75px]">
            <Link
              href={product?._url || 'https://www.shopmyexchange.com/'}
              aria-label="Go to PDP page"
              onClick={(event) => {
                handleSelectedProduct(event, product);
              }}
            >
              <Image
                onClick={(event) => {
                  handleClick(event);
                }}
                loader={({ src }) => src}
                className="h-full w-full cursor-pointer"
                src={matchingVariants[0]?.images?.[0]}
                alt={product?.name}
              />
            </Link>
          </div>
          <div className="flex flex-col place-content-between gap-y-3">
            <div className="flex flex-col gap-y-3">
              <Link
                href={product?._url || 'https://www.shopmyexchange.com/'}
                aria-label="Go to PDP page"
                onClick={(event) => {
                  handleSelectedProduct(event, product);
                }}
              >
                <span
                  onClick={(event) => {
                    handleClick(event);
                  }}
                  className="cursor-pointer text-sm font-bold leading-5 text-blue-900 hover:underline"
                >
                  {product?.name}
                </span>
              </Link>
              {!isMarketPlaceItem && (
                <PriceDetails product={product} setLoginModal={setLoginModal} fbpPrices={fbpPrices} />
              )}
            </div>
            {!isMarketPlaceItem && <div id={`BVRRInlineRating-${product?.productId}`}></div>}
            <Link href={product?._url || 'https://www.shopmyexchange.com/'}>
              <button
                onClick={(event) => {
                  setIsLoad(true);
                  handleSelectedProduct(event, product);
                }}
                className="h-9 w-[102px] rounded bg-blue-900 leading-4 text-white"
              >
                {formatMessage({ id: 'select', defaultMessage: 'Select' })}
              </button>
            </Link>
          </div>
        </div>
        <CgClose
          onClick={() => {
            handleAppendURL(matchingVariants?.[0]?.sku);
          }}
          className="absolute top-0.5 right-1 h-5 w-5 cursor-pointer text-gray-900"
        />
      </div>
      <LoginModal
        loginModal={loginModal}
        closeModal={closeLoginModal}
        closeAccountFlyout={closeLoginModal}
        loginCallBack={() => router.push(router.asPath)}
      />
    </>
  );
}
